/**
 * After Auth0 login/signup, the app often lands on `/` while `project_id` is still
 * in storage; HomeRedirect would send users to `/project/:id`. We set this flag
 * immediately before `loginWithRedirect` so the next `/` visit prefers the list.
 */
const SESSION_KEY = 'openda_post_login_prefer_project_list';

export function markPostLoginPreferProjectList(): void {
  try {
    sessionStorage.setItem(SESSION_KEY, '1');
  } catch {
    // ignore quota / private mode
  }
}

/** Returns true once, then clears the flag (one-shot). */
export function consumePostLoginPreferProjectList(): boolean {
  try {
    if (sessionStorage.getItem(SESSION_KEY) === '1') {
      sessionStorage.removeItem(SESSION_KEY);
      return true;
    }
  } catch {
    // ignore
  }
  return false;
}
